export const getElixirMids = (merchantDetails) =>
  merchantDetails.saleslocation_set
    .flatMap((item) => item.mid_set)
    .map((x) => ({
      system: "Elixir",
      system_id: x.mid,
    }));

export const getOtherMids = (merchantDetails) =>
  merchantDetails.system_set.map((x) => ({
    system: x.system,
    system_id: x.system_id,
  }));
